(function(){
    'use strict'

    angular
    .module('app.inscripciones')
    .controller('inscripciones.Edit', Edit);

    Edit.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment', 'pagosOnlineEnable'];

    function Edit($q, $scope, $animationsSrv, $routeParams, ApiBaseService, logger, $location, UserInfoService, moment, pagosOnlineEnable) {
    
        $animationsSrv.scrollToTop();

        const MONEDA_COLONES = 1;
        const MONEDA_DOLARES = 2;

        const apiInscripciones = 'api/Inscripciones';

        const ESTADO_PENDIENTE = 1;
        const ESTADO_CONFIRMADO = 2;

        let vm = this;

        vm.cuponValidationFired = false;

        vm.data = {
            eventoId: 0,
            estado: 0,
            tallaId: 0,
            estadoVacunacionId: 0,
            lateralidad: 0,
            sexo: 0,
            cuponCodigo: '',
            precioDescuento: 0,
            categoriaId: 0,
            aceptaDescargo: 0,
            paqueteId: 0,
            paqueteIncluye: ''
        };

        vm.title = 'Inscripciones';
        vm.id = $routeParams.id ? $routeParams.id : 0;
        vm.eventoId = $routeParams.eventoId ? $routeParams.eventoId : 0;


        vm.estados = [];
        vm.eventos = [];
        vm.tallas = [];
        vm.estadosVacunacion = [];
        vm.categorias = [];
        vm.paquetes = [];

        vm.uiData = {
            fechaNacimientoOpened: false,
            puedeCambiarEstado: false,
            descripcionGuardar: UserInfoService.esOrganizador() ? 'Inscribir' : 'Inscribirse',
            esOrganizador: UserInfoService.esOrganizador(),
            openFechaNacimiento(){
                this.fechaNacimientoOpened = !this.fechaNacimientoOpened;
            }
        };

        var promiseEstados = getComboData(vm.estados, 'api/InscripcionEstados', null, 'Error al cargar los estados');
        var promiseEventos = getComboData(vm.eventos, 'api/Eventos/All', null, 'Error al cargar los eventos');
        var promiseTallas = getComboData(vm.tallas, 'api/Tallas', null, 'Error al cargar las tallas');
        var promiseEstadosVacunacion = getComboData(vm.estadosVacunacion, 'api/EstadosVacunacion', null, 'Error al cargar los estados de vacunacion');
        //var promiseCategorias = getComboData(vm.categorias, 'api/Categorias/All', null, 'Error al cargar las Categorias');

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        async function getNombreByCedula(){
            var cedula = vm.data.cedula;
            var data = await ApiBaseService.getNombreByCedula(cedula)
            
            if(data !== null){
                var persona = data.results[0];

                vm.data.nombre = persona.firstname;
                vm.data.apellidos = persona.lastname1;
                vm.data.apellido2 = persona.lastname2;

                $scope.$apply();
            }
        };

        async function getNombreBeneficiarioByCedula(){
            var cedula = vm.data.cedulaBeneficiario;
            var data = await ApiBaseService.getNombreByCedula(cedula)
            
            if(data !== null){
                var persona = data.results[0];

                vm.data.nombreBeneficiario = persona.firstname;
                vm.data.beneficiarioApellido1 = persona.lastname1;
                vm.data.beneficiarioApellido2 = persona.lastname2;

                $scope.$apply();
            }
        };

        get();

        function get(){

            $q.all([promiseEstados, promiseEventos, promiseTallas, promiseEstadosVacunacion])
            .then(function(){

                if(vm.id != 0){
                    ApiBaseService.remoteController = apiInscripciones;
                    var promise = ApiBaseService.getAll([vm.id]);

                    promise
                    .then(function(data){
                        data.fechaNacimiento = moment(data.fechaNacimiento).toDate();
                        
                        if(data.paqueteId == 0)
                        {
                            data.precio = getPrecioEvento(data.eventoId);
                        }
                        else {
                            data.precio = getPrecioEventoConPaquete(data.eventoId, data.paqueteId);
                        }
                        
                        data.categoriaId = data.categoriaId == null ? 0 : data.categoriaId;

                        if(data.cuponId != null)
                        {
                            data.cuponCodigo = data.cupon.codigo;

                            if(data.paqueteId == 0)
                            {
                                data.precioDescuento = getPrecioEventoConCupon(data.eventoId, data.cupon);
                            }
                        }

                        var promiseCategorias = getComboData(vm.categorias, 'api/EventosCategorias', [data.eventoId], 'Error al cargar las Categorias')
                        .then(function(){

                            const categoria = vm.categorias.find((e)=>{return e.categoriaId == data.categoriaId;});

                            if(categoria == null)
                            {
                                data.categoriaId = 0;
                            }
                        });

                        var promisePaquetes = getComboData(vm.paquetes, 'api/Paquetes/All-Activos-Evento', [data.eventoId], 'Error al cargar los paquetes')
                        .then(function(){

                            const paquete = vm.paquetes.find((e)=>{return e.id == data.paqueteId;});

                            if(paquete == null)
                            {
                                data.paqueteId = 0;
                            }
                            else{
                                data.precio = getPrecioEventoConPaquete(data.eventoId, data.paqueteId);
                                data.paqueteIncluye = getPaqueteIncluye(data.paqueteId);

                                if(data.cuponId != null)
                                {
                                    data.precioDescuento = getPrecioEventoConCuponYPaquete(data.eventoId, data.paqueteId, data.cupon);
                                }
                            }
                        });

                        $q.all([promiseCategorias, promisePaquetes])
                        .then(function(){
                            vm.data = data;
                        });
                        
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el registro: ' + error.data.Message);
                                break;
                        }
                    });               
                }
                else
                {
                    if(!vm.uiData.esOrganizador)
                    {
                        const catPromise = getComboData(vm.categorias, 'api/EventosCategorias', [vm.eventoId], 'Error al cargar las Categorias');
                        const paqPromise = getComboData(vm.paquetes, 'api/Paquetes/All-Activos-Evento', [vm.eventoId], 'Error al cargar los Paquetes');
                        
                        $q.all([catPromise, paqPromise])
                        .then(function(){
                            cargarDatosUsuario();
                            vm.data.eventoId = vm.eventoId;

                            if(vm.data.paqueteId == 0)
                            {
                                vm.data.precio = getPrecioEvento(vm.eventoId);
                            }
                            else {
                                vm.data.precio = getPrecioEventoConPaquete(vm.eventoId, vm.paqueteId);
                            }
                            
                        });

                    }
                    else{
                        applyAtletaSeleccionado();
                    }
                    vm.data.estado = ESTADO_PENDIENTE;
                }
            });
        };

        vm.goConfirmarPago = function(inscripcionId){
            
            var path = '';

            if(pagosOnlineEnable) {
                path = '/editar-pago-v2/' + inscripcionId;
            }
            else {
                path = '/editar-pago/' + inscripcionId;
            }

            $location.path(path); 
        };

        vm.goEventos = function(){
            
            var path = '/eventos';

            $location.path(path); 
        };

        function cargarDatosUsuario()
        {
            const usuario = UserInfoService.getFullUser();

            vm.data.nombre = usuario.nombre;
            vm.data.apellidos = usuario.apellidos;
            vm.data.apellido2 = usuario.apellido2;
            vm.data.cedula = usuario.cedula;
            vm.data.cedulaBeneficiario = usuario.cedulaBeneficiario;
            vm.data.parentezcoBeneficiario = usuario.parentezcoBeneficiario;
            vm.data.nombreBeneficiario = usuario.nombreBeneficiario;
            vm.data.beneficiarioApellido1 = usuario.beneficiarioApellido1;
            vm.data.beneficiarioApellido2 = usuario.beneficiarioApellido2;
            vm.data.fechaNacimiento = moment(usuario.fechaNacimiento).toDate();
            vm.data.tallaId = usuario.tallaId;
            vm.data.estadoVacunacionId = usuario.estadoVacunacionId;
            vm.data.lateralidad = usuario.lateralidad;
            vm.data.sexo = usuario.sexo;
            vm.data.email = usuario.email;
            vm.data.telefono = usuario.telefono;
            vm.data.contactoEmergencia = usuario.contactoEmergencia;
            vm.data.telefonoContacto = usuario.telefonoContacto;
            vm.data.nombreEquipo = usuario.equipo;

            if(usuario.categoriaId != null)
            {
                const categoria = vm.categorias.find((e)=>{return e.categoriaId == usuario.categoriaId;});

                if(categoria == null)
                {
                    usuario.categoriaId = 0;
                }

                vm.data.categoriaId = usuario.categoriaId;
            }

        };

        function getMonedaSymbol(monedaId)
        {
            switch (monedaId) {
                case MONEDA_COLONES:
                    return '₡';
                case MONEDA_DOLARES:
                    return '$';
                default:
                    return '';
            }
        };

        function getPrecioEvento(eventoId)
        {
            if(vm.data.paqueteId == 0)
            {
                const evento = getEvento(eventoId);

                let monedaSymbol = getMonedaSymbol(evento.monedaId);

                return `${monedaSymbol} ${evento.precio}`;                
            }

            return null;
        };

        function getPrecioEventoConPaquete(eventoId, paqueteId)
        {
            if(eventoId != 0 && paqueteId != 0)
            {
                const paquete = vm.paquetes.find((e)=>{return e.id == paqueteId;});
                const evento = getEvento(eventoId);

                if(paquete != null && evento != null)
                {
                    const monedaSymbol = getMonedaSymbol(evento.monedaId);
                    return `${monedaSymbol} ${paquete.monto}`;
                }                
            }
            return null;
        };

        function getPrecioEventoConCupon(eventoId, cupon)
        {
            if(vm.data.paqueteId == 0)
            {
                const evento = getEvento(eventoId);

                let monedaSymbol = getMonedaSymbol(evento.monedaId);
    
                return `${monedaSymbol} ${evento.precio - cupon.monto}`;
            }

            return null;
        };

        function getPrecioEventoConCuponYPaquete(eventoId, paqueteId, cupon)
        {
            if(eventoId != 0 && paqueteId != 0)
            {
                const paquete = vm.paquetes.find((e)=>{return e.id == paqueteId;});
                const evento = getEvento(eventoId);

                let monedaSymbol = getMonedaSymbol(evento.monedaId);
    
                const montoDescuento = paquete.monto - cupon.monto;
                return `${monedaSymbol} ${montoDescuento >= 0 ? montoDescuento : 0}`;
            }
        };

        function getPaqueteIncluye(paqueteId)
        {
            const paquete = vm.paquetes.find((e)=>{return e.id == paqueteId;});
            return paquete ? paquete.incluye : '';
        }

        function getEvento(eventoId){
            return vm.eventos.find((evento) => {
                return evento.id == eventoId;
            });
        };

        function doFormValidations()
        {
            validateSelectProperty($scope.dataForm, vm.data, 'eventoId' );
            validateSelectProperty($scope.dataForm, vm.data, 'paqueteId' );
            validateSelectProperty($scope.dataForm, vm.data, 'estado' );
            validateSelectProperty($scope.dataForm, vm.data, 'tallaId' );
            validateSelectProperty($scope.dataForm, vm.data, 'estadoVacunacionId' );
            validateSelectProperty($scope.dataForm, vm.data, 'sexo' );
            validateSelectProperty($scope.dataForm, vm.data, 'lateralidad' );
            validateSelectProperty($scope.dataForm, vm.data, 'categoriaId' );
            validateSelectProperty($scope.dataForm, vm.data, 'aceptaDescargo' );
        };

        vm.save = function(){

            $scope.submitted = true;

            doFormValidations();

            if($scope.dataForm.$valid){
                if(!vm.data.id){
                    create();
                }
                else if($scope.dataForm.$dirty){
                    update();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }
            else{
                logger.error('Por favor corrija los datos');
            }    
        
        };

        function create() {
            ApiBaseService.remoteController = apiInscripciones;
            var promise = ApiBaseService.save(vm.data);
            
            promise
            .then(function(response){
                logger.success('Inscripción creada con éxito.');

                const inscripcionId = response.data.object.id;
                const estadoInscripcion = response.data.object.estado;

                if(estadoInscripcion === ESTADO_CONFIRMADO && !vm.uiData.esOrganizador)
                {
                    vm.goEventos();
                }
                else{
                    vm.goConfirmarPago(inscripcionId);
                }
                
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function update(){
            ApiBaseService.remoteController = apiInscripciones;
            var promise = ApiBaseService.update(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro modificado con éxito.');
                $location.path('/inscripciones');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.data = {
                eventoId: vm.eventoId,
                estado: 0,
                tallaId: 0,
                estadoVacunacionId: 0,
                lateralidad: 0,
                sexo: 0,
                cuponCodigo: '',
                precioDescuento: 0,
                categoriaId: 0,
                aceptaDescargo: 0
            };
            // Set back to pristine.
            $scope.dataForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.dataForm.$setUntouched();
        };

        function validateSelectProperty(form, object, property){
            if(object[property] == 0){
                form[property].$setValidity("different", false);
                return false;
            }
            else{
                form[property].$setValidity("different", true);
                return true;
            }
        };

        vm.onSelectChanged = function(property){

            switch (property) {
                case "eventoId":
                    onEventoIdChanged(property);
                    break;
                case "estado":
                    onEstadoChanged(property);
                    break;
                case "tallaId":
                    onTallaIdChanged(property);
                    break;
                case "estadoVacunacionId":
                    onEstadoVacunacionIdChanged(property);
                    break;
                case "sexo":
                    onSexoChanged(property);
                    break;
                case "lateralidad":
                    onLateralidadChanged(property);
                    break;
                case "categoriaId":
                    onCategoriaIdChanged(property);
                    break;
                case "paqueteId":
                    onPaqueteIdChanged(property);
                    break;
                default:
                    break;
            }
        };

        function onEstadoChanged(property)
        {
            validateSelectProperty($scope.dataForm, vm.data, property );
        };

        function onEventoIdChanged(property)
        {
            var result = validateSelectProperty($scope.dataForm, vm.data, property );

            vm.categorias = [];
            if(result)
            {
                vm.data.precio = getPrecioEvento(vm.data.eventoId);
                getComboData(vm.categorias, 'api/EventosCategorias', [vm.data.eventoId], 'Error al cargar las Categorias');
                getComboData(vm.paquetes, 'api/Paquetes/All-Activos-Evento', [vm.data.eventoId], 'Error al cargar los Paquetes');
            }
            else{
                vm.data.precio = '0';
            }
        };

        function onTallaIdChanged(property)
        {
            validateSelectProperty($scope.dataForm, vm.data, property );
        };

        function onSexoChanged(property)
        {
            validateSelectProperty($scope.dataForm, vm.data, property );
        };

        function onEstadoVacunacionIdChanged(property)
        {
            validateSelectProperty($scope.dataForm, vm.data, property );
        };

        function onLateralidadChanged(property)
        {
            validateSelectProperty($scope.dataForm, vm.data, property );
        };

        function onCategoriaIdChanged(property)
        {
            validateSelectProperty($scope.dataForm, vm.data, property );
        };

        function onPaqueteIdChanged(property)
        {
            var result = validateSelectProperty($scope.dataForm, vm.data, property );

            if(result)
            {
                vm.data.precio = getPrecioEventoConPaquete(vm.data.eventoId, vm.data.paqueteId);
                
                vm.data.paqueteIncluye = getPaqueteIncluye(vm.data.paqueteId);

                if(vm.data.cuponId != null)
                {
                    vm.data.precioDescuento = getPrecioEventoConCuponYPaquete(vm.data.eventoId, vm.data.paqueteId, vm.data.cupon);
                }
            }
        };

        vm.onCedulaLostFocus = function()
        {
            var cedula = vm.data.cedula;
            if(cedula.length >= 9) {
                getNombreByCedula();
            }
        };

        vm.onCedulaBeneficiarioLostFocus = function()
        {
            var cedula = vm.data.cedulaBeneficiario;
            if(cedula.length >= 9) {
                getNombreBeneficiarioByCedula();
            }
        };

        vm.onTextChanged = function(property){
            switch (property) {
                case "cuponCodigo":
                    onCuponCodigoChanged(property);
                    break;
                default:
                    break;
            }
        };

        function onCuponCodigoChanged(property)
        {
            if(vm.data.cuponCodigo != '' && !vm.cuponValidationFired)
            {
                vm.cuponValidationFired = !vm.cuponValidationFired;
                setTimeout(function(){ cuponValidation(); }, 3000);
               
            }
        };

        function cuponValidation()
        {
            if(vm.data.cuponCodigo != '')
            {
                vm.cuponValidationFired = !vm.cuponValidationFired;
                vm.data.cuponId = null;
                getCuponByCodigo();                
            }
        }

        function getCuponByCodigo(){
            ApiBaseService.remoteController = "api/Cupones/Codigo";
            var promise = ApiBaseService.getAll([vm.data.cuponCodigo, vm.data.eventoId])
            .then(function(data){
                vm.data.cuponId = data.id;
                logger.success("Cupon Asignado!");
                if(vm.data.paqueteId == 0)
                {
                    vm.data.precioDescuento = getPrecioEventoConCupon(data.eventoId, data);
                }
                else {
                    vm.data.precioDescuento = getPrecioEventoConCuponYPaquete(data.eventoId, vm.data.paqueteId, data);
                }
                vm.data.cupon = data;
            })
            .catch(function(error){
                logger.error(error.data.Message);
            }); 
            
            return promise;
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        vm.aceptarDescargo = function()
        {
            vm.data.aceptaDescargo = true;
            validateSelectProperty($scope.dataForm, vm.data, 'aceptaDescargo' );
        };

        vm.goToSeleccionarAtleta = function(){
            
            var path = '/seleccionar-atleta/';

            $location.path(path);
            
        };

        function applyAtletaSeleccionado()
        {
            if(vm.id == 0)
            {
                var atleta = UserInfoService.getAtleta();

                if(atleta != null)
                {
                    vm.data.nombre = atleta.nombre;
                    vm.data.apellidos = atleta.apellidos;
                    vm.data.apellido2 = atleta.apellido2;
                    vm.data.cedula = atleta.cedula;
                    vm.data.cedulaBeneficiario = atleta.cedulaBeneficiario;
                    vm.data.parentezcoBeneficiario = atleta.parentezcoBeneficiario;
                    vm.data.nombreBeneficiario = atleta.nombreBeneficiario;
                    vm.data.beneficiarioApellido1 = atleta.beneficiarioApellido1;
                    vm.data.beneficiarioApellido2 = atleta.beneficiarioApellido2;
                    vm.data.fechaNacimiento = moment(atleta.fechaNacimiento).toDate();
                    vm.data.tallaId = atleta.tallaId;
                    vm.data.estadoVacunacionId = atleta.estadoVacunacionId;
                    vm.data.lateralidad = atleta.lateralidad;
                    vm.data.sexo = atleta.sexo;
                    vm.data.email = atleta.email;
                    vm.data.telefono = atleta.telefono;
                    vm.data.contactoEmergencia = atleta.contactoEmergencia;
                    vm.data.telefonoContacto = atleta.telefonoContacto;
                    vm.data.nombreEquipo = atleta.equipo;

                    //limpiar datos del atleta
                    UserInfoService.setAtleta(null);
                }
            }
        }
    }
})();